// libs
import styled from "@emotion/styled";

// components
import BaseButton from "shared/components/Button";

// constants
import { BREAKPOINTS } from "shared/styles/base";

export const Container = styled.div`
    margin-top: 134px;
    width: 260px;

    @media screen and (max-width: ${BREAKPOINTS.MOBILE}px) {
        width: 100%;
        margin-top: 60px;
    }

    .message-container {
        padding-top: 14px;
        font-weight: 500;
        text-align: center;
    }
`;

export const Image = styled.img`
    position: absolute;
    left: 9px;
    height: 26px;
    width: 26px;
    top: 50%;
    transform: translateY(-50%);
`;

export const Button = styled(BaseButton)`
    position: relative;
    width: 100%;
    height: 45px;
    padding-left: 50px;
    font-weight: 500;
    border-radius: 2px;
    margin-bottom: 25px;
    justify-content: initial;
    text-transform: initial;
    font-size: 1.14rem;

    &.g-btn {
        border: 1px solid #000;
        background: #fff;
        color: #000;
    }

    &.fb-btn {
        background: #3b5998;
        color: #fff;
    }
`;
